import Application from "../../Application";
import IndexTypeGroupPresenter, {
  IIndexTypeGroupPresenter
} from "../presenter/IndexTypeGroupPresenter";
import { TGroupTreePresentationModel } from "../presenter/model/GroupTreePresentationModel";
import GetAllIndexTypeCategoriesInteractor from "./GetAllIndexTypeCategoriesInteractor";
import GetAllIndexTypeGroupsForCategoryInteractor from "./GetAllIndexTypeGroupsForCategory";
import GetAllIndexTypesInteractor from "./GetAllIndexTypesInteractor";

export default class ShowIndexTypeGroupsInteractor {
  private application: Application;
  private output?: IIndexTypeGroupPresenter;
  private getAllIndexTypeGroupsForCategoryInteractor: GetAllIndexTypeGroupsForCategoryInteractor;
  private getAllIndexTypesInteractor: GetAllIndexTypesInteractor;
  private getAllIndexTypeCategoriesInteractors: GetAllIndexTypeCategoriesInteractor;

  constructor({
    application,
    getAllIndexTypeCategories,
    getAllIndexTypes,
    getAllIndexTypeGroupsForCategory
  }: any) {
    this.application = application;
    this.getAllIndexTypeCategoriesInteractors = getAllIndexTypeCategories;
    this.getAllIndexTypeGroupsForCategoryInteractor = getAllIndexTypeGroupsForCategory;
    this.getAllIndexTypesInteractor = getAllIndexTypes;
  }

  private async getAllCategories() {
    return this.getAllIndexTypeCategoriesInteractors.execute();
  }
  private async getAllIndexTypes() {
    return this.getAllIndexTypesInteractor.execute();
  }

  private async getReferenceLists() {
    return Promise.all([this.getAllCategories(), this.getAllIndexTypes()]);
  }

  execute(categoryId: number) {
    this.output = IndexTypeGroupPresenter({
      application: this.application,
      initialState: {
        indexTypeGroups: {} as TGroupTreePresentationModel,
        categories: [],
        indexTypes: [],
        categoryId,
        createModalVisible: false,
        assignItemsModalVisible: false,
        createItemModalVisible: false,
        assignGroupsModalVisible: false,
        currentGroupId: NaN,
        currentGroupIndexTypeIds: [],
        currentGroupChildrenGroupIds: []
      }
    });
    this.getReferenceLists()
      .then(([indexTypeCategories, indexTypes]) =>
        this.output?.loadReferenceValues(indexTypeCategories, indexTypes)
      )
      .then(() =>
        this.getAllIndexTypeGroupsForCategoryInteractor.execute(categoryId)
      )
      .then(this.output.loadAllIndexTypeGroups);
    return this.output;
  }
}
